export enum Colors {
  brandPrimary1 = '#E6F0FE',
  brandPrimary3 = '#99C3F9',
  brandPrimary5 = '#3386F3',
  brandPrimary6 = '#0068F0',
  brandPrimary7 = '#004EB4',

  green1 = '#E6F8E8',
  green3 = '#9AE0A1',
  green5 = '#35C143',
  green6 = '#03B114',
  green7 = '#02850F',

  yellow1 = '#FFFBE6',
  yellow3 = '#FFEB99',
  yellow5 = '#FFD733',
  yellow6 = '#FFCD00',
  yellow7 = '#BF9A00',

  red1 = '#FFF1E6',
  red3 = '#FFC399',
  red4 = '#ff7875',
  red5 = '#FF8733',
  red6 = '#FF6900',
  red7 = '#BF4F00',

  orange1 = '#FFF7E6',
  orange3 = '#FFDD99',
  orange5 = '#FFBB33',
  orange6 = '#FFAA00',
  orange7 = '#BF8000',

  blue1 = '#E6F0FE',
  blue3 = '#99C3F9',
  blue5 = '#3386F3',
  blue6 = '#0068F0',
  blue7 = '#004EB4',

  gray1 = '#FFFFFF',
  gray2 = '#F6F7F8',
  gray3 = '#EBEDF1',
  gray4 = '#D8DBE2',
  gray5 = '#B1B7C5',
  gray6 = '#9DA5B7',
  gray7 = '#768190',
  gray8 = '#546274',
  gray9 = '#27292E',
  gray10 = '#1F2124',

  white = '#fff',
  black = '#000000',

  magenta6 = '#ef487c',
}

export const ScreenBreakpoints = {
  small: 1180,
  medium: 768,
  large: 991,
  extraLarge: 1280,
}

export const FontFamily = {
  primary: 'Segoe UI',
}

// overrides default Ant Design styles
export const antdDesignToken = {
  token: {
    colorPrimary: Colors.brandPrimary6,
    colorPrimaryActive: Colors.brandPrimary7,
    colorPrimaryHover: Colors.brandPrimary5,
    colorPrimaryBorderHover: Colors.brandPrimary5,
    colorPrimaryBorder: Colors.brandPrimary3,
    colorPrimaryBgHover: Colors.brandPrimary3,
    colorPrimaryBg: Colors.brandPrimary1,
    colorPrimaryTextHover: Colors.brandPrimary6,
    colorPrimaryTextActive: Colors.brandPrimary7,
    colorInfo: Colors.brandPrimary6,

    //make it like in antd v4
    borderRadius: 2,
    colorFillTertiary: '#f5f5f5',
  },
}

const theme = {
  colors: {
    primary: Colors.brandPrimary6,
    secondary: Colors.brandPrimary5,
    ternary: Colors.magenta6,

    appBackground: Colors.gray3,
    headerBackground: Colors.gray1,
    lightBackground: Colors.gray2,
    blueBackground: Colors.blue6,

    gray1: Colors.gray1,
    gray2: Colors.gray2,
    gray3: Colors.gray3,
    gray4: Colors.gray4,
    gray5: Colors.gray5,
    gray6: Colors.gray6,
    gray7: Colors.gray7,
    gray8: Colors.gray8,
    gray9: Colors.gray9,
    gray10: Colors.gray10,

    brandPrimary1: Colors.brandPrimary1,
    brandPrimary3: Colors.brandPrimary3,
    brandPrimary5: Colors.brandPrimary5,
    brandPrimary6: Colors.brandPrimary6,
    brandPrimary7: Colors.brandPrimary7,

    white: Colors.white,
    black: Colors.black,

    green1: Colors.green1,
    green3: Colors.green3,
    green5: Colors.green5,
    green6: Colors.green6,
    green7: Colors.green7,

    yellow1: Colors.yellow1,
    yellow3: Colors.yellow3,
    yellow5: Colors.yellow5,
    yellow6: Colors.yellow6,
    yellow7: Colors.yellow7,

    red1: Colors.red1,
    red3: Colors.red3,
    red4: Colors.red4,
    red5: Colors.red5,
    red6: Colors.red6,
    red7: Colors.red7,

    orange1: Colors.orange1,
    orange3: Colors.orange3,
    orange5: Colors.orange5,
    orange6: Colors.orange6,
    orange7: Colors.orange7,

    blue1: Colors.blue1,
    blue3: Colors.blue3,
    blue5: Colors.blue5,
    blue6: Colors.blue6,
    blue7: Colors.blue7,
  },
  fontSizes: {
    small: '12px',
    medium: '14px',
    large: '16px',
    extraLarge: '30px',
  },
  fontWeights: {
    normal: '400',
    semiBold: '600',
  },
}

export default theme
